<template>
  <button
    v-if="isVisible"
    @click="scrollToTop"
    class="fixed bottom-6 right-6 z-[9999] p-3 bg-black text-white rounded-full shadow-lg hover:bg-white hover:text-black transition duration-300"
  >
    <font-awesome-icon icon="arrow-up" class="text-lg" />
  </button>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const isVisible = ref(false);

const toggleVisibility = () => {
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  isVisible.value = scrollTop > 300;
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

onMounted(() => {
  window.addEventListener("scroll", toggleVisibility);
  toggleVisibility(); // trigger on mount
});

onUnmounted(() => {
  window.removeEventListener("scroll", toggleVisibility);
});
</script>

